(function ($) {
  'use strict';

  window.ys.TD2023 = new TD2023();
  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('page-template-skoda-titan-desert-2023')) {
    window.ys.TD2023Contest = new TD2023.Contest();
  }
}).bind(window)(jQuery);
